import { SelectOption } from '@/components/form-builder/form-builder.types';
import { DocSubmissionDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface DocSubmissionStateProps {
  response: any;
  dto: DocSubmissionDto;
  docSubmissionCategorySelected: SelectOption;
  isEqual: boolean;
  serverState: any;
}

export const docSubmissionInitialState: DocSubmissionStateProps = {
  response: [],
  dto: {
    nom: '',
    typeDossierId: undefined,
    validationDateRequired: false,
  },
  docSubmissionCategorySelected: {
    name: '',
    code: '',
  },
  isEqual: true,
  serverState: undefined,
};

export const docSubmissionStateStore = createStore(
  { name: 'docSubmission-state' },
  withProps<DocSubmissionStateProps>({
    ...docSubmissionInitialState,
  })
);
